// material-ui
import { useTheme } from '@mui/material/styles';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoIconDark from 'assets/images/logo-icon-dark.svg';
 * import logoIcon from 'assets/images/logo-icon.svg';
 * import { ThemeMode } from 'config';
 *
 */

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={theme.palette.mode === ThemeMode.DARK ? logoIconDark : logoIcon} alt="Mantis" width="100" />
     *
     */
    <svg xmlns="http://www.w3.org/2000/svg" width="98" height="104" viewBox="0 0 98 104">
      <rect x="6.00" y="4.00" width="86.00" height="19.00" rx="9.50" ry="9.50" fill="#3c64d0" />
      <rect x="6.00" y="33.00" width="62.00" height="20.00" rx="10.00" ry="10.00" fill="#3c64d0" />
      <ellipse cx="81.00" cy="43.50" rx="9.50" ry="9.50" fill="#3c64d0" />
      <rect x="6.00" y="59.00" width="30.00" height="20.00" rx="10.00" ry="10.00" fill="#3c64d0" />
      <ellipse cx="49.50" cy="69.00" rx="9.50" ry="9.50" fill="#3c64d0" />
    </svg>
  );
}
